module.exports = __webpack_public_path__ + "media/post-registration/learn-more@1x-dd5d7eee.png";